import { apiClient } from "../../../base/ApiClient";


export const createCommunicationNote = async (noteData) => {
  const response = await apiClient.post("/communications/communication-notes/", noteData);
  return response.data;
};

export const fetchCommunicationNotes = async (clientID, page = 1, page_size = 10) => {
  const response = await apiClient.get(
    `/communications/communication-notes/?client=${clientID}&page=${page}&page_size=${page_size}`
  );
  return response.data;
};